import { Button } from '@mui/material';
import BaseTable from 'components/ui/tables/BaseTable';
import useTopPanel from 'hooks/useTopPanel';
import React, { memo, useEffect, useState } from 'react';
import StaffAddEditModal from './ProductsAddEditModal';
import SimpleSearchInput from 'components/SearchInputNavbar';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import ProductsFilterDrawer from '../../../components/dashboard/ProductsFilterDrawer';

const Products = () => {
  const { setComponent } = useTopPanel();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const [refetch, setRefetch] = useState(false);
  const [openStaffModal, setOpenStaffModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [itemId, setItemId] = useState('');

  useEffect(() => {
    setComponent(<div className='component-title'>{t('products.title')}</div>);
  }, [i18n.language]);

  const onHistory = (data) => {
    navigate(`${data?.id}/history?customerName=${data?.name}`);
  };
  return (
    <div className='component-list-wrapper'>
      <div className='component-list-header mb-2'>
        <div className='header-actions-container py-3 flex flex-row items-center'>
          <div className='header-actions filter-box flex items-center px-4 w-full'>
            <Button
              variant='base'
              color='primary'
              startIcon={<i className='bi bi-filter' />}
              className='!mr-2'
              onClick={() => setOpenFilter(true)}
            >
              Filter
            </Button>
            <SimpleSearchInput inputKey='name' />
          </div>
          <div className='header-actions action-buttons-box py-3 px-4 flex items-center justify-center gap-2'>
            <Button
              variant='base'
              color='info'
              onClick={() => {
                setRefetch(true);
              }}
              disable={`${refetch}`}
            >
              <i
                className={`bi bi-arrow-repeat${
                  refetch ? ' animate-spin' : ''
                }`}
              />
            </Button>
            <Link
              to={`${process.env.REACT_APP_BACKEND_URL}/excel/products`}
              className='no-underline'
            >
              <Button variant='base' color='success'>
                <i className='bi bi-download' />
              </Button>
            </Link>
            <Button
              variant='base'
              color='success'
              onClick={() => setOpenStaffModal(true)}
            >
              <i className='bi bi-plus-circle' />
            </Button>
            <Button
              variant='base'
              color='default'
              onClick={() => setOpen(true)}
            >
              <i className='bi bi-gear' />
            </Button>
          </div>
        </div>
      </div>

      <div className='component-table-wrapper h-[calc(100vh-180px)]'>
        <BaseTable
          emitRefetch={{ refetch, setRefetch }}
          dataPath='admin/product/index'
          emitTableColumns={{ open, setOpen }}
          tableName='products'
          headCells={[
            { code: 'name', label: t('common.fields.simpleName') },
            { code: 'category', label: t('common.fields.category') },
            { code: 'unit', label: t('common.fields.unit') },
            { code: 'staff', label: t('common.fields.staff') },
          ]}
          columns={[
            { code: 'name' },
            { code: 'category', type: 'nested', childStr: 'name' },
            { code: 'unit', type: 'nested', childStr: 'name' },
            { code: 'staff', type: 'nested', childStr: 'name' },
          ]}
          actionsList={[
            {
              icon: 'bi bi-eye',
              btnColor: 'info',
              setOpen: () => {},
              setData: onHistory,
            },
          ]}
          actionModalEdit={{
            setOpen: setOpenStaffModal,
            setItemId: setItemId,
          }}
        />
      </div>
      {openStaffModal && (
        <StaffAddEditModal
          open={openStaffModal}
          setOpen={setOpenStaffModal}
          itemId={itemId}
          setItemId={setItemId}
          setRefetch={setRefetch}
        />
      )}

      <ProductsFilterDrawer open={openFilter} setOpen={setOpenFilter} />
    </div>
  );
};

export default memo(Products);
